var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoType(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.534 12.385V6.257a.569.569 0 01.876-.496l5.252 3.064a.583.583 0 010 1.007L9.41 12.896a.584.584 0 01-.876-.511z",
    stroke: "#575757",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.565.975H4.434a2.918 2.918 0 00-2.918 2.918v10.214a2.918 2.918 0 002.918 2.918h13.131a2.918 2.918 0 002.919-2.918V3.893A2.918 2.918 0 0017.565.975z",
    stroke: "#575757",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgVideoType;